<template>
  <div class="aside-box">
    <i class="close" @click="toggleAside"></i>
    <i class="aside-bg j-aside-bg"></i>
    <div class="platform-container j-aside-popup">
      <div class="showPlatform" @click="toggleAside"></div>
      <header class="platform-header">
        <div class="avatar-wrapper">
          <img class="avatar" :src="avatar" />
        </div>
        <div class="platform-account-contianer">
          <div
            class="user-wrapper platform-account--wapper"
            v-bind:class="{ fb: isFb }"
          >
            <p class="user-name">您好&nbsp;,&nbsp;{{ user.name }}</p>
            <button
              class="switch-user account-btn"
              v-on:click="switchAccount"
            ></button>
          </div>
          <div
            class="line"
            v-if="!isFb && isEnterGame && fbShareState && lineShareState"
          ></div>
          <div
            class="share-btn-wrapper platform-account--wapper"
            v-if="!isFb && isEnterGame"
          >
            <button
              class="line-share account-btn"
              v-on:click="doLineShare"
              v-show="lineShareState"
            ></button>
            <button
              class="fb-share account-btn"
              v-on:click="doFbShare"
              v-show="fbShareState"
            ></button>
          </div>
        </div>
      </header>

      <div class="platform-content">
        <nav class="tab-nav">
          <a
            class="tab"
            v-bind:class="{ active: showGift }"
            v-on:click="showGift = true"
            style="width: 100%"
          >
            <div class="text-wrapper">
              <i class="icon gift-tab-icon"></i>
              <span class="text">禮&nbsp;&nbsp;&nbsp;&nbsp;包</span>
            </div>
          </a>
          <a
            class="tab"
            v-bind:class="{ active: !showGift }"
            v-on:click="showGift = false"
            v-show="false"
          >
            <div class="text-wrapper">
              <i class="icon service-tab-icon"></i>
              <span class="text">客&nbsp;&nbsp;&nbsp;&nbsp;服</span>
            </div>
          </a>
          <!-- v-bind:style="{ left: showGift ? '0' : '50%' }" -->
          <div class="curentTabBorder" style="left: 0; width: 100%">
            <i class="currentTabIcon"></i>
          </div>
        </nav>
        <ul class="plaform-contaner-container">
          <transition name="fade">
            <li class="gift-container" v-show="showGift">
              <Gift v-on:showPopupWindow="giftPopupState = true"></Gift>
            </li>
          </transition>
          <transition name="fade">
            <li class="service" v-show="!showGift">
              <iframe
                v-if="isEnterGame && !isIE && !isIOS9"
                class="server-page j-server-page"
                :src="serviceSrc"
              ></iframe>
              <div
                v-if="!isEnterGame || isIE || isIOS9"
                class="showServicePhoneWrapper"
              >
                <div class="service-phone-container">
                  <p class="service-phone">
                    台灣專線
                    <a class="phone" href="tel:02-23560356">02-23560356</a>
                  </p>
                  <time class="service-time">每天09:00-22:00</time>
                </div>
              </div>
            </li>
          </transition>
        </ul>
      </div>
    </div>
    <transition name="fade">
      <GiftPopup
        v-on:closeGiftPopup="giftPopupState = false"
        v-show="giftPopupState"
      ></GiftPopup>
    </transition>
    <transition name="fade">
      <div
        v-show="
          showShareTipsFistTime &&
          isEnterGame &&
          !isFb &&
          (fbShareState || lineShareState)
        "
        class="share-tips"
        @click="hideShareTips"
      ></div>
    </transition>
    <transition name="fade">
      <div
        v-show="showShareSuccess"
        class="share-success"
        @click="showShareSuccess = false"
      >
        <div class="share-success-img"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { isFBApp, isPhone } from '../utile'
import { isIE, iOSversion } from '../utile/device'
import { mapGetters, mapActions } from 'vuex'
import { RESFRESH_TIPS_STATUS, SHARE_REWARD } from '../store/gamePage'
import { ACCOUNT_TYPE } from './Account'
import { fbShare, lineShare } from '../utile/fb'
import { getFbParam, getLineParam } from '../store/ultile'
import Gift from './Gift'
import GiftPopup from './GiftPopup'
import { POPUP_STYLE } from './TipPopUpIframe.vue'

let shareParams = {
  fb: {},
  line: {}
}

const AWARD_ID = {
  fb: 10005,
  line: 10006
}

export default {
  components: { Gift, GiftPopup },
  data() {
    let isIOS9 = false
    if (isPhone() && iOSversion() && iOSversion().length > 0) {
      isIOS9 = iOSversion()[0] < 10
    }
    return {
      isFb: isFBApp(),
      isIE: isIE(),
      isIOS9: isIOS9,
      fbShareState: false,
      lineShareState: false,
      showGift: true,
      giftPopupState: false,
      showShareSuccess: false
    }
  },
  computed: {
    avatar() {
      var timesmap = new Date().getTime()
      var avatar =
        this.user.id && this.user.avatar
          ? this.user.avatar + '?v=' + timesmap
          : ''
      return avatar
    },
    serviceSrc() {
      return `//service.gm99.com/?isH5=1&gameId=${this.gameId}&serverId=${this.roleInfo.serverId}&roleId=${this.roleInfo.roleId}&roleName=${this.roleInfo.roleName}/#/wo`
    },
    isEnterGame() {
      let res = this.roleInfo.serverId && this.roleInfo.roleId
      if (res) {
        // 进了游戏之后，请求分享参数
        this.getShareParams()
      }
      return res
    },
    ...mapGetters(['user', 'roleInfo', 'gameId', 'showShareTipsFistTime'])
  },
  methods: {
    toggleAside() {
      this.$emit('toggleAside')
    },
    switchAccount() {
      this.$emit('openAccountPopup', ACCOUNT_TYPE.switchAccount)
    },
    getShareParams() {
      let data = {
        serverId: this.roleInfo.serverId,
        roleId: this.roleInfo.roleId,
        roleName: this.roleInfo.roleName,
        name: this.user.name
      }
      getFbParam({
        achievementId: AWARD_ID.fb,
        ...data
      }).then(res => {
        if (res.errmsg) {
          return
        }
        this.fbShareState = true
        shareParams.fb = res
      })
      getLineParam({
        achievementId: AWARD_ID.line,
        ...data
      }).then(res => {
        if (res.errmsg) {
          return
        }
        this.lineShareState = true
        shareParams.line = res
      })
    },
    doFbShare() {
      this.gaStatistics({ eventName: 'share', data: { type: 'fb' } })
      fbShare(shareParams.fb).then(() => {
        this.getShareAward('fb')
      }, this.shareFail)
    },
    doLineShare() {
      this.gaStatistics({ eventName: 'line', data: { type: 'fb' } })
      lineShare(shareParams.line)
      this.getShareAward('line')
    },
    getShareAward(type) {
      this.$store
        .dispatch(SHARE_REWARD, {
          serverId: this.roleInfo.serverId,
          roleId: this.roleInfo.roleId,
          roleName: this.roleInfo.roleName,
          achievementId: AWARD_ID[type],
          fbid: '',
          postId: '',
          token: shareParams[type].token,
          name: this.user.name,
          type: type
        })
        .then(
          () => {
            this.showShareSuccess = true
          },
          () => {
            this.$store.commit('updateCommonTips', {
              msg: '領獎失敗',
              style: POPUP_STYLE.bad
            })
          }
        )
    },
    shareFail() {
      this.$store.commit('updateCommonTips', {
        msg: '分享失敗',
        style: POPUP_STYLE.bad
      })
    },
    hideShareTips() {
      this.$store.commit(RESFRESH_TIPS_STATUS, false)
    },
    ...mapActions(['gaStatistics'])
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/gamePage.scss';
.close {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.aside-bg {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 600px;
  background: #fdf6c7;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue